import { useState, useEffect } from 'react';
// Custom hook for api calls handling when we don't need to pass data over redux
export default function useFetch<T extends { [prop: string]: any }>(fn: Function, params: unknown[], defResult = {}, ...deps: unknown[]): {
  loading: boolean,
  result: T,
  error: any,
  setResult: React.Dispatch<React.SetStateAction<T>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
} {
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(defResult);
  const [error, setError] = useState(null);

  const fetcherWrapper = async () => {
    try {
      const { data } = await fn(...params);
      setResult(data);
      setLoading(false);
    } catch (error: any) {
      setResult(defResult);
      setLoading(false);
      setError(error);
    }
  };

  useEffect(() => {
    fetcherWrapper();
  }, [...deps]);

  return {
    loading,
    // @ts-ignore-error
    result,
    error,
    setResult,
    setLoading
  };
}
